<template>
<div class="flexwrap" id="landingpageBody">
  <div id="landingpageHeader"><!-- class="headerSolid"-->
  <img src="@/assets/landing_page/logo2.webp" alt="Learn and Watch" id="landingpageLogo" class="clickable" @click="landingHome">
  <div id="landingpageQuickLinks" v-if="step === steps.landing&&!isMobile">
    <span @click="goto('advantages')" class="clickable">Les avantages</span>
    <span @click="goto('method')" class="clickable">La méthode</span>
    <span @click="goto('science')" class="clickable">La science</span>
  </div>
    <div v-else></div>
 <!-- <div v-if="step === steps.landing || step === steps.guide" id="landingpageConnexion" class="clickable paddingRound lightplainTheme mediumShadow mediumRoundAngles flexwrap centercenter"
       @click="$router.push({name: 'login'})"
  > Se connecter
  </div>
  <div v-if="step === steps.landing" id="landingpageStart" class="clickable paddingRound mediumShadow mediumRoundAngles flexwrap centercenter"
       @click="startLogin(connexionTypes.signup)"
  > Commencer
  </div>-->
  <div id="bandeauAnnonce" class="mediumShadow flexwrap centercenter" style="height: 100%; position:absolute; top:0; right: 0; padding: 20px; border-radius: 0 0 10px 10px;">
    Learn and Watch est maintenant définitivement fermé. <br>Merci à tous pour votre soutien et votre confiance.
  </div>
</div>
  <transition name="fade" mode="out-in">
    <div v-if="step === steps.landing" :key="step"  id="landingpageCenterColumn" @scroll="isScrolling">

      <div id="landingpageContent">
        <div id="landingpageHook">
          <img class="landingpageImage withScrollBar" src="@/assets/landing_page/Queen.webp"/>
          <div id="landingpageTitle" class="softTextShadow">
            <h1>L’anglais<br/>en immersion<br/>dans les séries</h1>
          </div>
          <div id="landingpageSubtitle">
            <h2 style="font-size: 1em; font-weight: normal">Une méthode personnalisée pour progresser en anglais et enfin réussir à regarder une série en anglais sous-titrée anglais.
              <template v-if="!isMobile">Nous t’aidons à choisir une série adaptée à tes besoins et t’accompagnons tout au long de ton apprentissage.</template>
            </h2>
          </div>

          <h2 class="flexwrap centercenter clickable" @click="share" style="height: 1.2em" v-if="isMobile"><i class="fa-solid fa-share-nodes"></i></h2>

          <div id="landingpageFeaturesHighlight" class="mediumShadow" v-if="!isMobile">
            <div class="featureHighlight">
              <h2>{{textContent['hook1']['title']}}</h2>
              <span>{{textContent['hook1']['subtitle']}}</span>

            </div>
            <div class="vertical-line"></div>
            <div class="featureHighlight">
              <h2>{{textContent['hook2']['title']}}</h2>
              <span>{{textContent['hook2']['subtitle']}}</span>
            </div>
            <div class="vertical-line"></div>
            <div class="featureHighlight">
              <h2>{{textContent['hook3']['title']}}</h2>
              <span>{{textContent['hook3']['subtitle']}}</span>
            </div>


          </div>
          <carousel id="landingpageFeaturesHighlightMobile" :perPage="1" :paginationEnabled="true" :touchDrag="true" :autoplay="true" :loop="true"
                    :autoplayTimeout="3500" paginationActiveColor="var(--goalBackgroundColor2)" paginationColor="#ffffff88" :paginationPadding="5" v-else>
            <slide class="featureHighlightMobile">
              <h2>{{textContent['hook1']['title']}}</h2>
              <span>{{textContent['hook1']['subtitle']}}</span>
            </slide>
            <slide class="featureHighlightMobile">
              <h2>{{textContent['hook2']['title']}}</h2>
              <span>{{textContent['hook2']['subtitle']}}</span>
            </slide>
            <slide class="featureHighlightMobile">
              <h2>{{textContent['hook3']['title']}}</h2>
              <span>{{textContent['hook3']['subtitle']}}</span>
            </slide>
          </carousel>
        </div>

        <landing-page-paragraph id="advantages" title="Des avantages immédiats" :imageUrl="Bridgerton" 
        :imageLeft="true"
                                @startSignUp="startLogin(connexionTypes.signup)"
        >
          <landing-page-why></landing-page-why>
        </landing-page-paragraph>



        <landing-page-paragraph id="method" :imageLeft="false" :blue="true" :title="''"
                                @startSignUp="startLogin(connexionTypes.signup)">
          <landing-page-how></landing-page-how>
        </landing-page-paragraph>

        <landing-page-paragraph title="Ils parlent de nous" :imageUrl="BlackMirror" 
        :imageLeft="true"
                                @startSignUp="startLogin(connexionTypes.signup)"
        >
          <landing-page-review></landing-page-review>



        </landing-page-paragraph>
        <landing-page-paragraph id="science" title="Une méthode s'appuyant sur la recherche scientifique" :imageUrl="Breaking" :imageLeft="false" :blue="true"
                                @startSignUp="startLogin(connexionTypes.signup)"
        >
          <landing-page-science></landing-page-science>
        </landing-page-paragraph>
        <landing-page-paragraph title="Une équipe à ton écoute" :imageUrl="TheOfficeTeam" :imageLeft="true"
                                @startSignUp="startLogin(connexionTypes.signup)"
        >
          <landing-page-team></landing-page-team>

        </landing-page-paragraph>

        <div id="landingFooter" class="flexwrap paddingRound">
          <div class="textShadow">

        <span class="item">
            ©2021 Learn and Watch<template v-if="!isMobile"> -  Tous droits réservés</template>
        </span>
            <span class="item">|</span>
            <span class="item clickable">
            <a href="https://www.facebook.com/Learn-and-Watch-103125158025351/" style="text-decoration: none; color: #fff7ee; " target="_blank"><i class="fab fa-facebook-square"></i></a>
        </span>

            <span class="item clickable">
            <a href="https://twitter.com/Learn_and_Watch" style="text-decoration: none; color: #fff7ee; " target="_blank"><i class="fab fa-twitter"></i></a>
        </span>

            <span class="item clickable">
            <a href="http://instagram.com/learnandwatch_com/" style="text-decoration: none; color: #fff7ee" target="_blank"><i class="fab fa-instagram"></i></a>
        </span>

          </div>
        </div>

      </div>


    </div>

    <div :key="step" class="flexwrap centercenter" style="justify-self: center; width: 100%; height: 80%" v-else-if="step === steps.login">
      <router-view :connexionType="1"></router-view>
    </div>

    <div :key="step" style="width: 100vw; height: 100vh" v-else-if="step === steps.guide">
      <router-view></router-view>
    </div>
  </transition>


</div>
</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters, mapActions} from 'vuex';
import Bridgerton from "@/assets/landing_page/Bridgerton.webp";
import BlackMirror from "@/assets/landing_page/BlackMirror.webp";
import Breaking from "@/assets/landing_page/Breaking.webp";
import TheOfficeTeam from "@/assets/landing_page/TheOfficeTeam.webp";

export default {
  name: "landingpage",
  components: {
    LandingPageTeam: () => import(/* webpackPrefetch: true */ '@/components/landingPageTeam.vue'),
    LandingPageReview: () => import(/* webpackPrefetch: true */ '@/components/landingPageReview.vue'),
    LandingPageScience: () => import(/* webpackPrefetch: true */ '@/components/landingPageScience.vue'),
    LandingPageParagraph: () => import(/* webpackPrefetch: true */ '@/components/landingPageParagraph.vue'),
    LandingPageHow: () => import(/* webpackPrefetch: true */ '@/components/landingPageHow.vue'),
    Login: () => import(/* webpackPrefetch: true */ '@/components/login.vue'),
    LandingPageWhy: () => import(/* webpackPrefetch: true */ '@/components/landingPageWhy.vue'),
    Carousel,
    Slide,},

  created() {
    this.$webAuth.checkSession({}, (error, authResult) => {
      if(!error) {
        this.set_token(authResult.accessToken)
        this.$router.push({
          name: 'saison'
        })
      }
      else {
        console.log(error)
        if(this.routeName === 'guide') {
          this.step = this.steps.guide
          //this.$router.push({name: 'guide'})
        }
      else if(this.routeName === 'login') {
          this.step = this.steps.login
        }
      else if(!this.$cookies.isKey('user') && !this.$session.has('user')){
          if(!this.$isDebug){
            gtag('event', 'first landingPage', {
              'event_category': 'Navigation',
              'event_label': 'newComer'
            })

            fbq('track', 'newComer');
          }
        }
      }
    })
  },

  methods: {
    ...mapActions('global', [
        'set_token'
    ]),
    share(){
      if(!this.$isDebug){
        gtag('event', 'share', {
          'event_category': 'Navigation',
          'event_label': 'share'
        })

        fbq('track', 'shareClicked');
      }
      const shareData = {
        title: 'Learn and Watch',
        text: "Apprends l'anglais avec les séries !",
        url: 'https://www.learnandwatch.com/'
      }

      navigator.share(shareData)
    },
    startLogin() {
      if(!this.$isDebug){
        gtag('event', 'sign up clicked', {
          'event_category': 'Navigation',
          'event_label': 'signUpClicked'
        })

        fbq('track', 'signUpClicked');
      }
      this.step = this.steps.guide
      this.$router.push({name: 'guide'})
    },
    isScrolling(){
      var divs = document.getElementById('landingpageHeader'),
      limit = 400;
      if(this.isMobile){
        limit=50;
      }
      var st = document.getElementById('landingpageCenterColumn').scrollTop;

      if ((st-limit/4*3) <= limit) {
        divs.style.backgroundColor = 'hsla(210, 40%, 17%,'+(st-limit/4*3)/limit+')';
      }
      else{
        divs.style.backgroundColor = 'hsl(210, 40%, 17%)'
      }
    },
    goto(refName) {
      var element = document.getElementById(refName);
      var top = element.offsetTop-parseFloat(window.getComputedStyle(element, null).getPropertyValue('padding-top'));

      document.getElementById('landingpageCenterColumn').scrollTo(0, top);
    },
    landingHome(){
      this.$router.push({name: 'landingPage'})
      //this.step = this.steps.landing
      document.getElementById("landingpageCenterColumn").scrollTo({top: 0, behavior: 'smooth'});
    }
  },

  computed: {
    ...mapGetters('global', [
      'isMobile',
        'routeName'
    ])
  },

  watch:{
    step(){
      if(this.step !== this.steps.landing){
        document.getElementById('landingpageHeader').style.backgroundColor = 'var(--navBackgroundColor)';
        document.getElementById('landingpageHeader').style.width = '100%';
      }
      else{
        document.getElementById('landingpageHeader').style.backgroundColor = 'hsla(330, 5%, 20%, 0)';
      }
    },

    'routeName': function() {
      if(this.routeName === 'landingPage') {
        this.step = this.steps.landing;
        this.connexionType = this.connexionTypes.signup
      }
      else if(this.routeName === 'guide') {
        this.startLogin()
      }
      else if(this.routeName === 'login') {
        this.step = this.steps.login;
      }
    }
  },

  data() {
    return {
      textContent: {
        'hook1':{
          'title':'1500+ séries',
          'subtitle':'Le vocabulaire de toutes les séries Netflix anglophones'
        },
        'hook2':{
          'title':'En constante évolution',
          'subtitle':'De nouvelles fonctionnalités très régulièrement'
        },
        'hook3':{
          'title':'Méthode de base gratuite',
          'subtitle':'+ 7 jours d\'essai gratuit des fonctionnalités Premium'
        }
      },
      steps: {
        landing: 0,
        login: 1,
        guide: 2
      },
      step: 0,
      connexionTypes: {
        signup: 0,
        login: 1
      },
      connexionType: 0,
      Bridgerton,
      BlackMirror,
      Breaking,
      TheOfficeTeam


    }
  }
}
</script>

<style scoped>

  h1{
    font-size: 3em;
    font-weight: bold;
  }

  #landingpageBody{
    height: 100vh;
    width: 100vw;
    font-size: 1.1em;
    color: var(--standardColor);
    backdrop-filter: blur(0.5vw);
    -webkit-backdrop-filter: blur(0.5vw);
  }

  #landingpageCenterColumn{
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    background-color: var(--goalBackgroundColor3);
    scroll-behavior: smooth;
  }


  #landingpageHeader {
    position: absolute;
    top: 0;
    left: 0;
    height: 4vw;
    padding: 0 5vw 0 5vw;
    width: calc(100% - 10vw - 0.6vw);
    max-width: calc(100% - 10vw);
    display: grid;
    grid-template-columns: auto 1fr auto auto;
    grid-gap: 1vw;
    align-items: center;
    color: var(--goalBackgroundColor3);
    z-index: 100;
  }
  #landingpageLogo {
    height: 1.8vw;
    margin-right: 1vw;
  }

  #landingpageConnexion{
    width: 8vw;
  }

  #landingpageStart{
    width: 8vw;
    background-color: var(--goalBackgroundColor2);
    font-weight: bold;
  }
  #bandeauAnnonce{
    background-color: var(--goalBackgroundColor2);
    font-weight: bold;
  }

  #landingpageQuickLinks{
    font-weight: bold;
  }
  #landingpageQuickLinks>span{
    margin-right: 1vw;
  }

  #landingpageContent{
    display: grid;
  }

  #landingpageHook{
    display: grid;
    grid-gap: 1vw;
    padding: 8vw 25vw 0 25vw;
    width: calc(100% - 50vw);
    background-color: var(--navBackgroundColor);
    color: var(--goalBackgroundColor3);
  }

  #landingpageTitle{
    text-align: left;
    font-size: 1.3em;
    z-index: 5;

    width: calc(100%);
    padding: 0 5vw 0 5vw;
    /*transform: translate(-3.5vw, 0);*/
  }

  #landingpageSubtitle{
    padding: 0 5vw 0 5vw;
  }

  #landingpageFeaturesHighlight{
    height: fit-content;
    width: calc(100% - 2vw);
    margin: 4vw 0 4vw 0;
    border-radius: 2vw;
    display: grid;
    grid-template-columns: 1fr auto 1fr auto 1fr;
    padding: 1vw;
    grid-gap: 1vw;
    color: var(--goalColor);
    background-color: var(--goalBackgroundColor2)

  }

  .landingpageImage {
    z-index: 0;
    position: absolute;
    right: 0;
    top: 0;
    /*height: 43vw;*/
    width: 43vw;
    background-size: contain;
    background-position: top right;
    background-repeat: no-repeat;
  }
  .withScrollBar{
    transform: translateX(0.6vw);
  }

  .featureHighlight{
    padding: 0.5vw;
    color: var(--goalBackgroundColor3);
  }

  .vertical-line{
    width: 0.3vw;
    border-radius: 0.3vw;
    height:100%;
    background-color: var(--goalBackgroundColor3);
    justify-self: center;
    color: #00000000;
  }
  .scienceItem{
    background-color: var(--goalBackgroundColor3);
    color: var(--navBackgroundColor);
    margin: 0.5vw;
    padding: 1vw;
    border-radius: 1vw;
    max-width: 13vw;
    width: 13vw;
    font-weight: bold;
    font-size: 0.9em;
  }


  #landingPageLogin{
    width: 30vw;
    height: 30vw;
    background-color: var(--navBackgroundColor);
    color: var(--goalBackgroundColor3);
    border-radius: 30vw;
    padding: 5vw;
    margin-left: 30vw;
    justify-self: center;
  }

  #landingFooter{
    height: 3vw;
    color: var(--goalBackgroundColor3);
    background-color: var(--navBackgroundColor);
    justify-content: flex-end;
    align-content: center;
  }


  .item {
    margin: 0.4vw;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #eeeeee50;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--goalBackgroundColor);
  }

  @media screen and (max-device-width: 767px) {
    h1{
      font-size: 2.2em;
    }
    #landingpageBody{
      height: 100vh;
      width: 100vw;
      font-size: 4vw;
      color: var(--standardColor);
      backdrop-filter: blur(0.5vw);
      -webkit-backdrop-filter: blur(0.5vw);
    }
    #landingpageHeader {
      height: 14vw;
      padding: 1vw 3vw 0 2vw;
      width: calc(100% - 5vw - 2vw);
      max-width: calc(100% - 5vw);
      grid-template-columns: auto 1fr auto auto;
      grid-gap: 2vw;
      align-items: center;
    }
    #landingpageLogo {
      height: 7vw;
      margin-left: 2vw;
    }
    #landingpageConnexion{
      width: 24vw;
    }
    #landingpageStart{
      width: 24vw;
    }

    #landingpageHook{
      display: grid;
      grid-gap: 4vw;
      padding: 30vw 0 0 0;
      width: 100%;
      max-width: 100%;
    }

    #landingpageTitle{
      text-align: left;
      font-size: 1.3em;
      z-index: 5;
      padding: 0 8vw 0 8vw;
      width: calc(100% - 16vw);
      transform: translate(0, 0);
    }

    #landingpageSubtitle{
      padding: 0 8vw 0 8vw;
      width: calc(100% - 16vw);
      max-width: calc(100% - 16vw);
    }
    #landingpageSubtitle>h3{
      font-size: 1.2em;
    }

    #landingpageFeaturesHighlightMobile{
      height: fit-content;
      width: 100vw;
      display: block;
      justify-self: center;
      padding: 3vw 0 3vw 0 ;
    }

    .featureHighlightMobile{
      padding: 5vw;
      margin: 0 17vw 0 17vw;
      border-radius: 4vw;
      background-color: var(--goalBackgroundColor2);
      max-width: 56vw;
      height: 26vw;
      font-size: 1.1em;
      display: grid;
      grid-template-rows: auto 1fr;
      align-items: center;
      align-content: center;
    }
    .featureHighlightMobile>h2{
      font-size: 1.2em;
    }

    .landingpageImage {
      /*height: 80vw;*/
      width: 75vw;
    }
    .withScrollBar{
      transform: translateX(1vw);
    }


    .featureHighlight>span{
      text-align: center;
    }

    .vertical-line{
      height: 100%;
      border-radius: 1vw;
      width:1vw;
    }
    .scienceItem{
      background-color: var(--goalBackgroundColor3);
      color: var(--standardColor);
      margin: 0.5vw;
      padding: 1vw;
      border-radius: 1vw;
      max-width: 13vw;
      width: 13vw;
      font-weight: bold;
      font-size: 0.9em;
    }


    #landingPageLogin{
      width: 90vw;
      height: 80vh;
      background-color: transparent;
      border-radius: 0;
      padding: 5vw;
      margin-left: 0;
    }

    #landingFooter{
      height: 8vw;
      color: var(--goalBackgroundColor3);
      background-color: var(--navBackgroundColor);
      align-content: center;
      font-size: 1.1em;
    }


    .item {
      margin: 1.5vw;
    }

  }

</style>
